import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private error = new Subject<string>();
  public error$ = this.error.asObservable();

  private success = new Subject<string>();
  public success$ = this.success.asObservable();

  emitError(message: string): void {
    this.error.next(message);
  }

  emitSuccess(message: string): void {
    this.success.next(message);
  }
}
